import type {
  CompRef,
  DocumentServicesObject,
} from '@wix/document-services-types';
import type { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';

type HelpEndpoint = 'widget' | 'settings_modal';

export const createTpaHelpService = (
  platformApiMethods: PlatformApiMethods,
  documentServicesAPI: DocumentServicesObject,
): TpaHelpService => {
  const getHelpId = async (
    source: HelpEndpoint,
    deviceType: string,
    selectedComponent?: CompRef,
    appDefId?: string,
    widgetId?: string,
  ) => {
    if (!selectedComponent && !appDefId) {
      return '';
    }

    if (selectedComponent) {
      const compType =
        documentServicesAPI.components.getType(selectedComponent);

      if (documentServicesAPI.tpa.isTpaByCompType(compType)) {
        const gfppDataFromApp =
          documentServicesAPI.platform.controllers.getStageData(
            selectedComponent,
          );
        const helpId = gfppDataFromApp?.gfpp?.[deviceType]?.helpId;

        if (helpId) {
          return helpId;
        }
      }
    }

    if (!appDefId) {
      return '';
    }

    const appMarketData = await documentServicesAPI.tpa.appMarket.getDataAsync(
      appDefId,
    );
    const widgetData = appMarketData.widgets?.find(
      (widget) => widget.widgetId === widgetId,
    );
    const settingsHelpId = widgetData?.settings?.helpId ?? '';

    if (source === 'settings_modal') {
      return appMarketData?.dashboard?.helpId ?? settingsHelpId;
    }

    if (widgetId) {
      const editorMode = await platformApiMethods.editor.info.getEditorMode();
      const isMobile = editorMode === 'mobile';

      return (isMobile ? widgetData?.mobileHelpId : widgetData?.helpId) || '';
    }
  };

  return { getHelpId };
};

export interface TpaHelpService {
  getHelpId: (
    source: HelpEndpoint,
    deviceType: string,
    selectedComponent?: CompRef,
    appDefId?: string,
    widgetId?: string,
  ) => Promise<string>;
}
